import { returnErrors } from './errorAction';
import {
  GET_JOB_LIST_LOADING, GET_JOB_LIST, SUBMIT_JOB_SUCCESS, GENERATE_JOB_FROM_PROMPT_SUCCESS, GENERATE_JOB_DESCRIPTION_SUCCESS, ENHANCE_JOB_DESCRIPTION_SUCCESS, DELETE_JOB_SUCCESS, DUPLICATE_JOB_SUCCESS, GET_JOB_BY_ID_SUCCESS, GET_SKILLS_LIST, ADD_NEW_SKILL, CREATE_JOB_ASSESSMENT_SUCCESS,
  GET_TAGS_LIST, ADD_NEW_TAG,
  GET_HIRING_STAGES, GET_CANDIDATE_HIRING_STAGE,
  FETCH_AVAILABLE_SLOTS,
  GET_QUALIFY_QUESTIONS,
  CLEAR_QUALIFYING_QUESTIONS,
  SET_SELECTED_QUESTION,
  CLEAR_INITIATE_WEB_CALL,
  INITIATE_WEB_CALL_SUCCESS,
} from '../Types/types';
import { getJobApiCall, postJobApiCall, deleteJobApiCall, putJobApiCall, patchJobApiCall, getApiErrorDetail, } from '../../utils/jobRequest';
import { getApiCall, handle403Logout, postApiCall } from '../../utils/request';


export const fetchJobs = (page = 1, pageSize = 10, jobStatusId = null, createdBy = "", jobTypeId = "", fromDate = "", toDate = "", search = "") => async (dispatch) => {
  dispatch({ type: GET_JOB_LIST_LOADING });

  try {
    let query = `jobs?page=${page}&page_size=${pageSize}`;
    if (jobStatusId) query += `&job_status_id=${jobStatusId}`;
    if (createdBy) query += `&created_by=${createdBy}`;
    if (jobTypeId) query += `&job_type_id=${jobTypeId}`;
    if (fromDate && toDate) query += `&from_date=${fromDate}&to_date=${toDate}`;
    if (search) query += `&search=${encodeURIComponent(search)}`;

    const res = await getJobApiCall(query);
    dispatch({
      type: GET_JOB_LIST,
      payload: { jobs: res.data.data, pagination: res.data.pagination },
    });
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return false;
  }
};



export const submitJob = (jobData) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs`, jobData);
    if (response?.status === 200) {
      dispatch({ type: SUBMIT_JOB_SUCCESS, payload: response.data.data });
      return response.data.data;
    } else {
      if (response?.response?.status === 402) return { __error402: true };
      if (response?.response?.status === 403) {
        returnErrors(dispatch, response?.response?.data?.detail || 'You do not have permission to create jobs', 403);
        return { __error403: true };
      }
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    if (error?.response?.status === 402) return { __error402: true };
    if (error?.response?.status === 403) {
      returnErrors(dispatch, error.response?.data?.detail || 'You do not have permission to create jobs', 403);
      return { __error403: true };
    }
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return false;
  }
};

//Genetate AI Job Description
export const generateJobDescriptionWithAI = (jobData, jobId) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/ai/description`, jobData);
    if (response?.status === 200) {
      dispatch({ type: GENERATE_JOB_DESCRIPTION_SUCCESS, payload: response.data });
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//Enhance AI Job Description
export const enhanceJobDescriptionWithAI = (jobData, jobId) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/ai/enhance-description`, jobData);
    if (response?.status === 200) {
      dispatch({ type: ENHANCE_JOB_DESCRIPTION_SUCCESS, payload: response.data });
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};


//deleting the job
export const deleteJob = (jobId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(`jobs/${jobId}`);
    if (response.status === 200) {
      returnErrors(dispatch, 'Job deleted sucessfully', 200);
      return dispatch({ type: DELETE_JOB_SUCCESS, payload: jobId });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//duplicate job
export const duplicateJob = (jobId, payload = {}) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/duplicate`, payload);
    if (response?.status === 200 || response?.status === 201) {
      const data = response.data?.data || response.data;
      dispatch({ type: DUPLICATE_JOB_SUCCESS, payload: data });
      return { success: true, data };
    } else {
      return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to duplicate job" };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to duplicate job" };
  }
};

//get indidual job details
// Pass { auth: false } to fetch without the Authorization header (only some pages need this).
export const fetchJobById = (jobId, { auth = true } = {}) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}`, { auth });
    if (response?.status === 200) {
      const job = response.data.data;
      dispatch({ type: GET_JOB_BY_ID_SUCCESS, payload: job });
      return job;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};


//Edit job details
export const updateJob = (jobId, jobData) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}`, jobData);
    if (response?.status === 200) {
      return response?.data;
    } else {
      if (response?.response?.status === 402) return { __error402: true };
      console.log("status 402");
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    if (error?.response?.status === 402) return { __error402: true };
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return { success: false, message: "Failed to update job" };
  }
};

export const fetchDashboardStats = () => async (dispatch) => {
  dispatch({ type: "FETCH_DASHBOARD_STATS_LOADING" });
  try {
    const res = await getJobApiCall("jobs/dashboard-stats");
    if (res?.status === 200) {
      dispatch({ type: "FETCH_DASHBOARD_STATS_SUCCESS", payload: res.data.data });
    } else {
      returnErrors(dispatch, res?.data?.responseMessages?.[0]?.message, res?.status);
      dispatch({ type: "FETCH_DASHBOARD_STATS_FAILURE" });
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to fetch dashboard stats", error?.response?.status);
    dispatch({ type: "FETCH_DASHBOARD_STATS_FAILURE" });
  }
};

export const clearLatestJob = () => (dispatch) => {
  dispatch({ type: "CLEAR_LATEST_JOB" });
  setTimeout(() => {
    dispatch({ type: "CLEAR_LATEST_JOB_DONE" });
  }, 300);
};

//fetching all skills
export const fetchAllSkills = () => async (dispatch) => {
  try {
    const response = await getApiCall('skill/list');
    dispatch({ type: GET_SKILLS_LIST, payload: response.data.skills });
  } catch (error) {
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//creating new skills
export const createSkill = (name) => async (dispatch) => {
  try {
    const response = await postApiCall('skill/create', { name });
    if (response.status === 200) {
      const newSkill = { id: response.data.id, name };
      dispatch({ type: ADD_NEW_SKILL, payload: newSkill });
      return newSkill;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return null;
  }
};

//fetching all tags
export const fetchAllTags = () => async (dispatch) => {
  try {
    const response = await getJobApiCall('jobs/tags');
    if (response?.status === 200) {
      dispatch({ type: GET_TAGS_LIST, payload: response.data?.data || response.data || [] });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//creating new tags
export const createTag = (name) => async (dispatch) => {
  try {
    const response = await postJobApiCall('jobs/tags', { name });
    if (response?.status === 200 || response?.status === 201) {
      const newTag = response.data?.data || { id: response.data?.id, name };
      dispatch({ type: ADD_NEW_TAG, payload: newTag });
      return newTag;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return null;
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    return null;
  }
};

//fetching hiring tages
export const getHiringStages = (job_id) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${job_id}/hiring-stages/?is_active=true`);
    const mappedStages = response.data.data.map(item => ({
      job_id: item.job_id,
      hiring_stage_id: item.hiring_stage_id,
      sequence: item.sequence,
      is_active: item.is_active,
      is_enabled: item.is_enabled,
      is_locked: item.is_locked,
      data: item.data,
      id: item.id,
      name: item.hiring_stage.name,
      hiring_stage: item.hiring_stage
    }));
    dispatch({ type: GET_HIRING_STAGES, payload: mappedStages });
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//Assign stage
export const assignedStage = (jobId, obj) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/hiring-stage/assign`, obj);
    if (response?.status === 200) {
      returnErrors(dispatch, response?.data?.message, response?.status);
      return response.status;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

//Get candidate hiring stages
export const getCandidateHiringStage = (id) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`job-candidate-hiring-stages/${id}`);
    dispatch({ type: GET_CANDIDATE_HIRING_STAGE, payload: response.data.data });
  } catch (error) {
    // returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    const message = error?.response?.data?.responseMessages?.[0]?.message || error?.response?.data?.message || "Access denied";
    const status = error?.response?.status;
    returnErrors(dispatch, message, status);
    throw error;
  }
};

//scheduled hiring stage
export const scheduledHiringStage = (obj, jobId) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/hiring-stage/schedule`, obj);
    if (response?.status === 200) {
      returnErrors(dispatch, response?.data?.message, response?.status);
      return response.status;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
    }
  } catch (error) {
    // returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    const detail = error?.response?.data?.detail;
    const message =
      (typeof detail === "string" ? detail : detail?.message) ||
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong during scheduling please contact administrator.";
    return { success: false, message };
  }
};

//apply for job
export const applyForJob = (jobId, formData) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/job-candidates/apply`, formData,)
    if (response?.status === 200) {
      returnErrors(dispatch, response?.data?.message, response?.status);
      return { success: true, status: response.status, data: response?.data?.data, message: response?.data?.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
      return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message };
    }
  } catch (error) {
    const detail = error?.response?.data?.detail;
    const message =
      (typeof detail === "string" ? detail : detail?.message) ||
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong during upload.";
    return { success: false, message };
  }
};

export const fetchAvailableSlots = (jobId, targetDate, timezone) => async (dispatch) => {
  try {
    let query = `jobs/${jobId}/hiring-stage/slots/available?target_date=${targetDate}`;
    if (timezone) {
      query += `&timezone=${encodeURIComponent(timezone)}`;
    }
    const res = await getJobApiCall(query);
    if (res?.status === 200) {
      dispatch({ type: FETCH_AVAILABLE_SLOTS, payload: res.data.data || [] });
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data?.message || 'Failed to fetch slots', error?.response?.status);
  }
};

export const fetchVideoInterviewSlots = (jobCandidateHiringStageId, timezone) => async (dispatch) => {
  try {
    let url = `video-interview/${jobCandidateHiringStageId}/slots`;
    if (timezone) url += `?timezone=${encodeURIComponent(timezone)}`;
    const res = await getJobApiCall(url);
    if (res?.status === 200) {
      dispatch({ type: FETCH_AVAILABLE_SLOTS, payload: res.data.data || [] });
    }
  } catch (error) {
    returnErrors(dispatch, error?.response?.data?.message || 'Failed to fetch video interview slots', error?.response?.status);
  }
};

export const bookVideoInterviewSlot = (jobCandidateHiringStageId, payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`video-interview/${jobCandidateHiringStageId}/book-slot`, payload);
    if (response?.status === 200) {
      return response.status;
    }
    const message = response?.data?.detail || response?.data?.message || "Booking failed";
    return { success: false, message };
  } catch (error) {
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong during booking";
    return { success: false, message };
  }
};

//get job details from doc
export const extractJobDetailsFromDoc = (formData) => async (dispatch) => {
  try {
    const response = await postJobApiCall("jobs/extract-details", formData, true);
    if (response?.status === 200) {
      return response.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to extract job details", error?.response?.status);
  }
};

//generate job details from prompt
export const generateJobFromPrompt = (promptData) => async (dispatch) => {
  try {
    const response = await postJobApiCall("job-agent/chat", promptData);
    if (response?.status === 200) {
      dispatch({ type: GENERATE_JOB_FROM_PROMPT_SUCCESS, payload: response.data });
      return response.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to generate job from prompt", error?.response?.status);
  }
};

//get qualifying questions
export const fetchQualifyingQuestions = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}/qualify-questions/`);
    if (response?.status === 200) {
      dispatch({ type: GET_QUALIFY_QUESTIONS, payload: response.data.data });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to extract qualifying questions", error?.response?.status);
  }
};

export const clearQualifyingQuestions = () => ({ type: CLEAR_QUALIFYING_QUESTIONS });

//get qualifying questions by id
export const fetchQualifyingQuestionById = (jobId, questionId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}/qualify-questions/${questionId}`);
    if (response?.status === 200) {
      dispatch({ type: SET_SELECTED_QUESTION, payload: response.data.data });
      return response.data.data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to extract qualifying question", error?.response?.status);
  }
};

//save qualifying questions
export const saveQualifyingQuestion = (jobId, question) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/qualify-questions`, question);
    if (response?.status === 200) {
      dispatch({ type: "SAVE_QUALIFY_QUESTION_SUCCESS", payload: response.data.data });
      return { success: true };
    } else {
      const message = getApiErrorDetail(response) || "Failed to save qualifying question";
      returnErrors(dispatch, message, response?.response?.status);
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message = getApiErrorDetail(error) || "Failed to save qualifying question";
    returnErrors(dispatch, message, error?.response?.status);
    return { success: false, message };
  }
}

//update qualifying questions
export const updateQualifyingQuestion = (jobId, questionId, question) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}/qualify-questions/${questionId}`, question);
    if (response?.status === 200) {
      dispatch({ type: "UPDATE_QUALIFY_QUESTION_SUCCESS", payload: response.data.data });
      return { success: true };
    } else {
      const message = getApiErrorDetail(response) || "Failed to update qualifying question";
      returnErrors(dispatch, message, response?.response?.status);
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message = getApiErrorDetail(error) || "Failed to update qualifying question";
    returnErrors(dispatch, message, error?.response?.status);
    return { success: false, message };
  }
};

//delete qualifying questions
export const deleteQualifyingQuestion = (jobId, questionId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(`jobs/${jobId}/qualify-questions/${questionId}`);
    if (response?.status === 200) {
      dispatch({ type: "UPDATE_QUALIFY_QUESTION_SUCCESS", payload: response.data.data });
      return true;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return false;
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to delete qualifying question", error?.response?.status);
    return false;
  }
};

//reorder qualifying questions
export const reorderQualifyingQuestions = (jobId, orderedIds) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}/qualify-questions/reorder`, { ordered_ids: orderedIds });
    if (response?.status === 200) {
      const data = Array.isArray(response.data?.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
      if (data.length) dispatch({ type: GET_QUALIFY_QUESTIONS, payload: data });
      return true;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return false;
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to reorder qualifying questions", error?.response?.status);
    return false;
  }
};

//get evaluation variants (evaluation fit)
export const fetchEvaluationVariants = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}/evaluation-variants/`);
    if (response?.status === 200) {
      const data = response.data.data || response.data || [];
      dispatch({ type: "GET_EVALUATION_VARIANTS", payload: data });
      return { success: true, data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to fetch evaluation fit variants", error?.response?.status);
    return { success: false };
  }
};

//create evaluation variant
export const createEvaluationVariant = (jobId, payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/evaluation-variants/`, payload);
    if (response?.status === 200 || response?.status === 201) {
      const data = response.data.data || response.data;
      dispatch({ type: "ADD_EVALUATION_VARIANT", payload: data });
      return { success: true, data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to create evaluation fit" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to create evaluation fit" };
  }
};

//update evaluation variant
export const updateEvaluationVariant = (jobId, variantId, payload) => async (dispatch) => {
  try {
    const response = await patchJobApiCall(`jobs/${jobId}/evaluation-variants/${variantId}`, payload);
    if (response?.status === 200) {
      const data = response.data.data || response.data;
      dispatch({ type: "UPDATE_EVALUATION_VARIANT", payload: data });
      return { success: true, data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update evaluation fit" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to update evaluation fit" };
  }
};

//delete evaluation variant
export const deleteEvaluationVariant = (jobId, variantId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(`jobs/${jobId}/evaluation-variants/${variantId}`);
    if (response?.status === 200 || response?.status === 204) {
      dispatch({ type: "DELETE_EVALUATION_VARIANT", payload: variantId });
      return { success: true };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to delete evaluation fit" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to delete evaluation fit" };
  }
};

//initiate Web voice call
export const initiateWebVoiceCall = (jobId, candidateId, hiringStageId) => async (dispatch) => {
  dispatch({ type: CLEAR_INITIATE_WEB_CALL });
  try {
    const payload = { job_candidate_hiring_stage_id: hiringStageId, };
    const response = await postJobApiCall(`jobs/${jobId}/voice-call/initiate-web/${candidateId}`, payload);
    const data = await response.data;
    if (response?.status === 200) {
      dispatch({ type: INITIATE_WEB_CALL_SUCCESS, payload: data, });
      return data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return false;
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to save qualifying question", error?.response?.status);
    return false;
  }
};

export const initiateQueueWebCall = (jobId, candidateId, hiringStageId, extraPayload = {}) => async (dispatch) => {
  try {
    const payload = { job_candidate_hiring_stage_id: hiringStageId, ...extraPayload }
    const response = await postJobApiCall(`jobs/${jobId}/voice-call/queue-web-call/${candidateId}`, payload)
    const data = await response.data;
    if (response?.status === 200) {
      return data;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return false;
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to save qualifying question", error?.response?.status);
    return false;
  }
}

export const getLanguages = () => async (dispatch) => {
  try {
    const response = await getJobApiCall('languages/');
    if (response?.status === 200) {
      const languages = response.data.data;
      dispatch({ type: "SET_LANGUAGES", payload: languages });
      return { success: true, data: languages };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return false;
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to Fetch Languages", error?.response?.status);
    return false;
  }
};

export const uploadResumesFromUrls = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`candidates/upload-resume-urls`, payload);
    if (response?.status === 200) {
      return { success: true, data: response.data.data, message: response.data.message };
    } else {
      const message = response?.data?.detail || response?.data?.message || "Upload failed";
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed";
    return { success: false, message };
  }
};

export const generatePreScreeningQuestions = (jobId, body) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/qualify-questions/generate-from-job-details`, body);
    if (response?.status === 200) {
      return { success: true, data: response.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

// stageOrder: selected stage ids in the order candidates move through them
export const setupAutomations = (jobId, stageOrder = []) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`automations/setup-automation-unified?job_id=${jobId}`, {
      stage_order: stageOrder,
    });
    if (response?.status === 200) {
      dispatch({ type: "SETUP_AUTOMATIONS_SUCCESS", payload: response.data.data });
      return true;
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
      return false;
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to setup automations", error?.response?.status);
    return false;
  }
};

export const listVideoPanelists = (jobId, jobHiringStageId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/panelists`
    );
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.message || "Failed to fetch panelists" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to fetch panelists" };
  }
};

export const listVideoRules = (jobId, jobHiringStageId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/rules`
    );
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.message || "Failed to fetch rules" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to fetch rules" };
  }
};

export const updateVideoRule = (jobId, jobHiringStageId, ruleId, ruleData) => async (dispatch) => {
  try {
    const response = await putJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/rules/${ruleId}`,
      ruleData
    );
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update rule" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to update rule" };
  }
};

export const updateVideoPanelist = (jobId, jobHiringStageId, panelistId, panelistData) => async (dispatch) => {
  try {
    const response = await putJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/panelists/${panelistId}`,
      panelistData
    );
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update panelist" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to update panelist" };
  }
};

export const updateVideoSlot = (jobId, jobHiringStageId, ruleId, slotId, slotData) => async (dispatch) => {
  try {
    const response = await putJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/rules/${ruleId}/slots/${slotId}`,
      slotData
    );
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update slot" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to update slot" };
  }
};

export const deleteVideoPanelist = (jobId, jobHiringStageId, panelistId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/panelists/${panelistId}`
    );
    if (response?.status === 200 || response?.status === 204) {
      return { success: true };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to delete panelist" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to delete panelist" };
  }
};

export const deleteVideoRule = (jobId, jobHiringStageId, ruleId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/rules/${ruleId}`
    );
    if (response?.status === 200 || response?.status === 204) {
      return { success: true };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to delete rule" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to delete rule" };
  }
};

export const deleteVideoSlot = (jobId, jobHiringStageId, ruleId, slotId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/rules/${ruleId}/slots/${slotId}`
    );
    if (response?.status === 200 || response?.status === 204) {
      return { success: true };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to delete slot" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to delete slot" };
  }
};

export const createVideoPanelist = (jobId, jobHiringStageId, panelistData) => async (dispatch) => {
  try {
    const response = await postJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/panelists/`,
      panelistData
    );
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to create panelist" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to create panelist" };
  }
};

export const createVideoRule = (jobId, jobHiringStageId, ruleData) => async (dispatch) => {
  try {
    const response = await postJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/rules`,
      ruleData
    );
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to create rule" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to create rule" };
  }
};

export const createVideoSlot = (jobId, jobHiringStageId, ruleId, slotData) => async (dispatch) => {
  try {
    const response = await postJobApiCall(
      `jobs/${jobId}/hiring-stages/${jobHiringStageId}/video-interview/rules/${ruleId}/slots`,
      slotData
    );
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to create slot" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to create slot" };
  }
};

export const getChatLink = (jobId, jobTitle) => async (dispatch) => {
  try {
    const payload = {
      job_id: jobId,
      channel: "messenger",
      campaign: `${jobTitle}-hiring`,
      source_id: jobId,
      source_type: "ad",
    };
    const response = await postJobApiCall("chat-link", payload);
    if (response?.status === 200) {
      return {
        success: true,
        chat_url: response.data?.chat_url || response.data?.data?.chat_url,
        my_chat_url: response.data?.my_chat_url || response.data?.data?.my_chat_url,
      };
    }
    returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to get chat link", response?.status);
    return { success: false };
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to get chat link", error?.response?.status);
    return { success: false };
  }
};

export const updateJobHiringStageSettings = (jobId, jobHiringStageId, stageData) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}/hiring-stages/${jobHiringStageId}`, stageData);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update video settings" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Failed to update video settings" };
  }
};

//generate dynamic voice assistant prompt (opening greeting / screening script / end call rules / compiled prompt)
export const generateDynamicVoicePrompt = (formData) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`dynamic-voice-call/generate-prompt`, formData);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to generate prompt" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.detail || error?.response?.data?.message || "Failed to generate prompt" };
  }
};

//get job team & round-robin assignment settings
export const fetchJobAssignmentSettings = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}/assignment-settings`);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to load assignment settings" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to load assignment settings" };
  }
};

//update job team & round-robin assignment settings
export const updateJobAssignmentSettings = (jobId, payload) => async (dispatch) => {
  try {
    const response = await patchJobApiCall(`jobs/${jobId}/assignment-settings`, payload);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update assignment settings" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to update assignment settings" };
  }
};

//get job team members (ACL)
export const fetchJobAccessList = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}/access`);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to load job team" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to load job team" };
  }
};

//add job team member
export const addJobAccessMember = (jobId, companyUserId, fullCandidateAccess = false) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/access`, {
      company_user_id: companyUserId,
      full_candidate_access: fullCandidateAccess,
    });
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to add team member" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to add team member" };
  }
};

//add every user of the given companies to the job team
export const addJobAccessByCompanies = (jobId, companyIds, fullCandidateAccess = false) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`jobs/${jobId}/access/by-companies`, {
      company_ids: companyIds,
      full_candidate_access: fullCandidateAccess,
    });
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data?.data || response.data, message: response.data?.message };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to add companies to job team" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to add companies to job team" };
  }
};

//update job team member full candidate access
export const updateJobAccessMember = (jobId, companyUserId, fullCandidateAccess) => async (dispatch) => {
  try {
    const response = await patchJobApiCall(`jobs/${jobId}/access/${companyUserId}`, { full_candidate_access: fullCandidateAccess });
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update full candidate access" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to update full candidate access" };
  }
};

//remove job team member
export const removeJobAccessMember = (jobId, companyUserId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(`jobs/${jobId}/access/${companyUserId}`);
    if (response?.status === 200 || response?.status === 204) {
      return { success: true };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to remove team member" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to remove team member" };
  }
};

//get round-robin pool
export const fetchJobRoundRobinPool = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}/round-robin`);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to load round-robin pool" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to load round-robin pool" };
  }
};

//save round-robin pool (order = array order)
export const setJobRoundRobinPool = (jobId, companyUserIds) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}/round-robin`, { company_user_ids: companyUserIds });
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to save round-robin pool" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to save round-robin pool" };
  }
};

//assign / reassign candidate (companyUserId = null clears the assignment)
export const updateCandidateAssignee = (jobId, candidateId, companyUserId) => async (dispatch) => {
  try {
    const response = await patchJobApiCall(`jobs/${jobId}/job-candidates/${candidateId}/assignee`, { company_user_id: companyUserId });
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to update assignee" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to update assignee" };
  }
};

//job insights overview (fromDate/toDate as YYYY-MM-DD; omit both for current totals)
export const fetchJobOverview = (jobId, fromDate = "", toDate = "") => async (dispatch) => {
  try {
    let query = `jobs/${jobId}/overview`;
    if (fromDate && toDate) query += `?from_date=${fromDate}&to_date=${toDate}`;
    const response = await getJobApiCall(query);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to load job overview" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to load job overview" };
  }
};

//job insights activity feed, newest first (before = next_before cursor from the previous page)
export const fetchJobOverviewActivity = (jobId, limit = 5, fromDate = "", toDate = "") => async (dispatch) => {
  try {
    let query = `jobs/${jobId}/overview/activity?limit=${limit}`;
    if (fromDate && toDate) query += `&from_date=${fromDate}&to_date=${toDate}`;
    const response = await getJobApiCall(query);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return { success: false, message: response?.response?.data?.detail || response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Failed to load job activity" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.parsedMessage || error?.response?.data?.detail || error?.response?.data?.message || "Failed to load job activity" };
  }
};

// Job email settings (Reply-To + multi CC for candidate emails)
export const fetchJobEmailSettings = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`jobs/${jobId}/email-settings`);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return {
      success: false,
      message:
        response?.response?.data?.detail ||
        response?.data?.responseMessages?.[0]?.message ||
        response?.data?.message ||
        "Failed to load job email settings",
    };
  } catch (error) {
    handle403Logout(error);
    return {
      success: false,
      message:
        error?.parsedMessage ||
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Failed to load job email settings",
    };
  }
};

export const updateJobEmailSettings = (jobId, payload) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}/email-settings`, payload);
    if (response?.status === 200) {
      return { success: true, data: response.data?.data || response.data };
    }
    return {
      success: false,
      message:
        response?.response?.data?.detail ||
        response?.data?.responseMessages?.[0]?.message ||
        response?.data?.message ||
        "Failed to update job email settings",
    };
  } catch (error) {
    handle403Logout(error);
    return {
      success: false,
      message:
        error?.parsedMessage ||
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Failed to update job email settings",
    };
  }
};
